import { useEffect, useRef } from "react";

/** Intervalo por defecto entre refrescos (ms). */
export const APPOINTMENTS_REFRESH_INTERVAL_MS = 12_000;

/**
 * Ejecuta loadData al montar y cada intervalMs mientras enabled.
 * Usa ref para no depender de la identidad de loadData (evita reiniciar el intervalo en cada render).
 */
export function usePeriodicLoadData(
  loadData,
  intervalMs = APPOINTMENTS_REFRESH_INTERVAL_MS,
  enabled = true
) {
  const loadDataRef = useRef(loadData);
  loadDataRef.current = loadData;

  useEffect(() => {
    if (!enabled) return;
    if (typeof loadDataRef.current !== "function") return;
    loadDataRef.current();
    const id = setInterval(() => {
      loadDataRef.current();
    }, intervalMs);
    return () => clearInterval(id);
  }, [enabled, intervalMs]);
}
